module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/register-keyvisual_ja_pc-f5bce51047c14ab998fc77a8e3c21aa5.png";